import { render } from "./login-header.vue?vue&type=template&id=da667736&scoped=true"
import script from "./login-header.vue?vue&type=script&lang=js"
export * from "./login-header.vue?vue&type=script&lang=js"

import "./login-header.vue?vue&type=style&index=0&id=da667736&scoped=true&lang=less"

import exportComponent from "/dev/shm/repo/piano-dp60u5626l1a/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-da667736"]])

export default __exports__